module.exports = __webpack_public_path__ + "img/home-01.e5997c9e.jpg";